import { listModelConfigs, type ModelConfigEntry } from '@/client/config/models.config';
import { getModelConfig } from '@/client/store/modelStore';

export interface BatchModelOption {
  key: string;
  label: string;
  description?: string;
  config: ModelConfigEntry;
}

export const isBatchSupportedModel = (config?: ModelConfigEntry | null): config is ModelConfigEntry => {
  if (!config) return false;
  const pollingEnabled = config.polling?.enabled === true;
  const hasWorkspaceForm = Boolean(config.workspace?.form);
  return pollingEnabled && hasWorkspaceForm;
};

export const listBatchModelOptions = (): BatchModelOption[] =>
  listModelConfigs()
    .filter((config) => isBatchSupportedModel(config))
    .sort((a, b) => Number(b.visible !== false) - Number(a.visible !== false))
    .map((config) => ({
      key: config.modelKey,
      label: config.label ?? config.modelKey,
      description: config.description ?? undefined,
      config,
    }));

export const getModelDisplayLabel = (modelKey: string | null | undefined): string | null => {
  if (!modelKey) return null;
  const config = getModelConfig(modelKey);
  if (!config) return null;
  return config.label ?? modelKey;
};
